


























































import Vue from "vue";
import CardTable from "@/components/Card/CardTable/CardTable.vue";
import TabsTable from "@/components/Tabs/TabsTable.vue";
import DeviceGraphCard from "@/views/Dashboard/Management/Device/DeviceGraphCard.vue";
import DeviceCardBox from "@/views/Dashboard/Management/Device/DeviceCardBox.vue";
import DeviceDownload from "@/views/Dashboard/Management/Device/DeviceDownload.vue";
import { PickStr, typeOfDisplay } from "@/types/types";
import Utils from "@/utils/utils";

interface DeviceCardsInterface {
  tabs: Array<string>;
  currentTab: string;
  time: string;
  labels: Array<string>;
  maxLabels: Array<string>;
}

export default Vue.extend({
  name: "DeviceCards",
  components: { CardTable, TabsTable, DeviceGraphCard, DeviceDownload, DeviceCardBox },
  props: {
    selected: {
      type: Array as () => Array<string>
    },
    shouldDisplayDescriptionPanel: {
      type: Function
    },
    onSelectChange: {
      type: Function
    },
    searchFilter: {
      type: Object
    },
    customFilter: {
      type: Function
    },
    formattedData: {
      type: Array
    },
    currentItems: {
      type: Function
    },
    selectedToggleAll: {
      type: Function
    },
    selectedChange: {
      type: Function
    },
    sortBy: {
      type: String,
      default: undefined
    },
    sortDesc: {
      type: Boolean,
      default: undefined
    },
    defaultItemPerPage: {
      type: Number,
      default: 10
    },
    pagination: {
      type: Function,
      default: () => undefined
    }
  },
  created() {
    const params = Utils.getUrlParameters();
    if (params.get("page")) {
      this.currentTab = params.get("page") === typeOfDisplay.CARD ? "Général" : "Graphique";
    } else {
      const params = Utils.getUrlParameters();
      params.set("page", "card");
      history.pushState(null, "", "?" + params.toString());
    }
    this.labels = this.format_data_labels();
    this.time = "weeks";
    this.maxLabels = this.format_data_labels();
    this.time = "days";
  },
  data(): DeviceCardsInterface {
    return {
      tabs: ["Général", "Graphique", "Téléchargement"],
      currentTab: "Général",
      time: "days",
      labels: [],
      maxLabels: []
    };
  },
  methods: {
    parse_url_parameters() {
      const params = Utils.getUrlParameters();
      if (params.get("page")) {
        this.currentTab = params.get("page") === typeOfDisplay.CARD ? "Général" : "Graphique";
      } else {
        const params = Utils.getUrlParameters();
        params.set("page", "card");
        history.pushState(null, "", "?" + params.toString());
      }
    },
    format_data_labels(): Array<string> {
      const labels = [];
      const time_: PickStr<any> = {
        hours: new Date(new Date().setHours(0, 0, 0)),
        days: new Date(new Date(new Date().setHours(0, 0, 0)).setDate(new Date().getDate() - 3)),
        weeks: new Date(new Date(new Date().setHours(0, 0, 0)).setDate(new Date().getDate() - 7))
      };

      const time: Date = time_[this.time];

      while (time < new Date(new Date().setHours(new Date().getHours() - 2))) {
        labels.push(Utils.transformDateToYMDHMS(time));
        time.setHours(time.getHours() + 1);
      }
      return labels;
    },
    OnTabClick(tab: string): void {
      const params = Utils.getUrlParameters();
      params.set("page", tab === "Général" ? "card" : "graph");
      history.pushState(null, "", "?" + params.toString());
      this.currentTab = tab;
    }
  },
  watch: {
    time() {
      this.labels = this.format_data_labels();
    },
    $route: {
      handler(): void {
        this.parse_url_parameters();
      }
    }
  }
});
